import script from "./AddressLookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressLookup.vue?vue&type=script&setup=true&lang=ts"

import "./AddressLookup.vue?vue&type=style&index=0&id=5ff0f84f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff0f84f"]])

export default __exports__